import { Library } from './Library';

/**
 * Modules — GEN-60, the last of the four library screens.
 *
 * A module is where generation lands and the object a reviewer works on most, and it was
 * the one kind with no list of its own. Two filters beyond the shared three, which is the
 * parameter `library-screens.md` asks for rather than a second component.
 *
 * No `newPath`, for the reason `Paths` gives: a module is generated, `NewGeneration` owns
 * that, and GEN-60 puts making one out of scope.
 */
export function Modules() {
  return (
    <Library
      kind="MODULE"
      title="Modules"
      detailPath={(id) => `/library/modules/${id}`}
      narrows={['course', 'path', 'job']}
      publishes
    />
  );
}
